/* Ethos Shoes - Auto-expand filter disclosures on desktop */
(function() {
  function openFilters() {
    if (window.innerWidth < 990) return;

    var disclosures = document.querySelectorAll('.facets__disclosure.js-filter');
    disclosures.forEach(function(details) {
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFilters);
  } else {
    openFilters();
  }

  // Re-run after Shopify AJAX filter updates
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        setTimeout(openFilters, 100);
      }
    });
  });

  var facetsForm = document.querySelector('.facets-container');
  if (facetsForm) {
    observer.observe(facetsForm, { childList: true, subtree: true });
  }

  // Also re-run on window resize
  window.addEventListener('resize', openFilters);
})();
